import { render, staticRenderFns } from "./DownloadCsvButton.vue?vue&type=template&id=06db546b&scoped=true&"
import script from "./DownloadCsvButton.vue?vue&type=script&lang=js&"
export * from "./DownloadCsvButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCsvButton.vue?vue&type=style&index=0&id=06db546b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db546b",
  null
  
)

export default component.exports